require('./edit_block.js');

PegasusTemplate.MirrorRowCommand = PegasusTemplate.EditBlockCommand.extend({
  description: function(){
    return Em.I18n.t('command_descriptions.shifted_columns');
  }.property()
});
